import { render, staticRenderFns } from "./mpMenu.vue?vue&type=template&id=413313b3&scoped=true&"
import script from "./mpMenu.vue?vue&type=script&lang=js&"
export * from "./mpMenu.vue?vue&type=script&lang=js&"
import style0 from "./mpMenu.vue?vue&type=style&index=0&id=413313b3&prod&lang=less&scoped=scoped&"
import style1 from "./mpMenu.vue?vue&type=style&index=1&id=413313b3&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413313b3",
  null
  
)

export default component.exports